export default __webpack_public_path__ + "static/CircularXXWeb-Bold-b47e1e549516948eea3643309579c529.woff2";